

<footer>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 text-center pb-3">
        <a *ngIf="!(LoginStatus$ | async) as LoginStatus" href="javascript:void(0)" class="text-white d-inline-block fs-13 text-underline pb-2"
           (click)="OnNotProfileClick()">
           <!-- id="{{LoginStatus}}" -->
           <i class="fas fa-sign-out-alt fs-16"></i> &nbsp; Not a {{profilename}}?</a>
        <p class="fs-12 text-white pt-3"> The mission of {{utilityService.getPortalName()}} Medical Affairs is to empower clinical decision-making through the communication of {{utilityService.getPortalName()}}'s data by providing high-quality, timely, scientifically-balanced, and evidence-based information in response to unsolicited requests for medical information.</p>
        <p class="fs-12 text-white pt-3"> {{utilityService.getPortalName()}} provides this information in response to your specific unsolicited request for your personal use and general education purposes only.  The information provided is not intended to offer an opinion or provide medical advice, but rather to allow you to draw your own conclusions. </p>
        <p class="fs-12 text-white pt-3"> This web portal is intended only for healthcare professionals practicing in the US. </p>
      </div>
    </div>
    <div class="row border-bottom pb-2">
      <div class="col-md-12">
        <div class="footerLinks text-center">
          <a *ngIf="enabledFooterItems.isResources" routerLink="resources">Resources</a>
          <a href="https://www.scimaxglobal.com/privacy-policy/" target="_blank">Privacy Statement</a>
          <a href="javascript:void(0)" (click)="openContactModal(template)">Contact Us</a>
          <a href="https://www.techsolcorp.com/application-privacy-notice/" target="_blank">Terms of Use</a>
          <a *ngIf="enabledFooterItems.isSitemap" routerLink="sitemap">Sitemap</a>
        </div>
      </div>
    </div>
    <!-- <div class="row pt-2">
        <div class="col-md-12">
             <ul class="quicklinks">
             <a href="" class="text-white d-block fs-13 text-underline pb-2">Copyright information - © 1996-2021 {{utilityService.getPortalName()}}. All Rights Reserved</a>
             </ul>
        </div>
    </div> -->
    <div class="row pt-2">
      <div class="col-md-10 col-12">
        <div class="row">
          <div class="col-md-3 col-12"></div>
          <div class="col-md-9 col-12">
            <p class="text-white d-block fs-13 pt-2 text-center">
              Copyright information - © 1996-{{copyrightCurrentYear}}
              {{utilityService.getPortalName()}}. All Rights Reserved
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-12">
        <p class="text-white fs-9 footer-logo">
          Powered by<a href="https://www.scimaxglobal.com/" target="_blank">
            <img src="./assets/images/scimax.png" alt="">
          </a>
        </p>
      </div>
    </div>
  </div>
</footer>

<ng-template #template>
  <div class="modal-header">
    <h5 class="modal-title w-100 d-block">
      Contact Us
      <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="modalRef.hide()">
        <i class="fas fa-times"></i>
      </span>
    </h5>
  </div>
  <div class="modal-body px-0">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-md-12">
          <ul class="contactUs">
            <li>
              <div class="row">
                <div class="col-md-12">
                  <span class="text-center"><i class="fas fa-phone-alt"></i></span>
                  <small>1-888-GLU-VIVA available on Monday – Friday from 9am - 7pm.</small>
                </div>
                <div class="col-md-12">
                  <span class="text-center"><i class="fas fa-envelope"></i></span>
                  <a href="mailto:medinfo@gluviva.com?subject=Medical%20Information%20Request" class="d-block fs-13">medinfo@gluviva.com</a>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
